import { render, staticRenderFns } from "./MList.vue?vue&type=template&id=c3822d8e"
import script from "./MList.vue?vue&type=script&lang=js"
export * from "./MList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports